var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CardContent, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ECompetitionType } from "../../enums";
import { CardWithShadow, MatchCallToActionButton, MatchVsContainer } from "../components";
export var SingleMatchCard = function (props) {
    var competitionType = props.competitionType, matchDate = props.matchDate, matchLocation = props.matchLocation, homeTeamName = props.homeTeamName, homeTeamLogoUrl = props.homeTeamLogoUrl, awayTeamName = props.awayTeamName, awayTeamLogoUrl = props.awayTeamLogoUrl, isMatchFinished = props.isMatchFinished, isMatchLive = props.isMatchLive, isTimeKnown = props.isTimeKnown, homeTeamScore = props.homeTeamScore, homeTeamAfterMatchPenaltyScore = props.homeTeamAfterMatchPenaltyScore, awayTeamScore = props.awayTeamScore, awayTeamAfterMatchPenaltyScore = props.awayTeamAfterMatchPenaltyScore, reportId = props.reportId, liveTickerKey = props.liveTickerKey, buyTicketLink = props.buyTicketLink;
    var _a = useState(1), scale = _a[0], setScale = _a[1];
    var _b = useState(""), competitionLogoUrl = _b[0], setCompetitionLogoUrl = _b[1];
    var _c = useState(""), prettyDate = _c[0], setPrettyDate = _c[1];
    useEffect(function () {
        switch (competitionType) {
            case ECompetitionType.FIRST_LEAGUE:
                setCompetitionLogoUrl("/images/competition_logos/2022/SNL-lezeci.png");
                break;
            case ECompetitionType.CUP:
                setCompetitionLogoUrl("/images/competition_logos/2022/Pokal-lezeci.png");
                break;
            case ECompetitionType.FRIENDLY:
                setCompetitionLogoUrl("");
                break;
            case ECompetitionType.CHAMPIONS_LEAGUE:
                setCompetitionLogoUrl("/images/competition_logos/2022/UCL.png");
                break;
            case ECompetitionType.EUROPA_LEAGUE:
                setCompetitionLogoUrl("/images/competition_logos/2022/UEL.png");
                break;
            case ECompetitionType.CONFERENCE_LEAGUE:
                setCompetitionLogoUrl("/images/competition_logos/2022/UECL.png");
                break;
        }
    }, [competitionType]);
    useEffect(function () {
        setPrettyDate(matchDate.toLocaleDateString(["sl-sl"], {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            weekday: "long",
        }));
    }, [matchDate]);
    return (_jsx(CardWithShadow, __assign({ onMouseEnter: function () { return setScale(1); }, onMouseLeave: function () { return setScale(1); }, fixedWidth: 288, sx: {
            display: "flex",
            flexDirection: "column",
        } }, { children: _jsx(CardContent, __assign({ sx: {
                p: 3
            } }, { children: _jsxs(Grid, __assign({ container: true, sx: {
                    height: "100%",
                }, direction: "column", justifyContent: "flex-start", alignItems: "stretch" }, { children: [_jsx(Grid, __assign({ item: true, sx: {
                            height: "60px",
                        }, justifyContent: "center", alignItems: "center", container: true }, { children: competitionType !== ECompetitionType.FRIENDLY &&
                            _jsx("img", { src: competitionLogoUrl, alt: "", style: {
                                    maxWidth: "120px", maxHeight: "60px", transform: "scale(".concat(scale, ")"),
                                    transition: "transform 1.5s",
                                    padding: 0,
                                } }) })), _jsxs(Grid, __assign({ item: true, container: true, direction: "column", justifyContent: "center", alignItems: "center", sx: { mt: 3, height: "55px" } }, { children: [_jsx(Typography, __assign({ variant: "bodyL" }, { children: prettyDate })), _jsx(Typography, __assign({ sx: { mt: "-11px" }, variant: "bodyL" }, { children: matchLocation }))] })), _jsx(Grid, __assign({ item: true, sx: { mt: 1 } }, { children: _jsx(MatchVsContainer, { homeLogoFileName: homeTeamLogoUrl, homeTeamName: homeTeamName, awayLogoFileName: awayTeamLogoUrl, awayTeamName: awayTeamName, scale: scale, score: (isMatchLive || isMatchFinished) && homeTeamScore !== undefined && awayTeamScore !== undefined
                                ? "".concat(homeTeamScore, ":").concat(awayTeamScore)
                                : undefined, afterMatchPenaltyScore: isMatchFinished && homeTeamAfterMatchPenaltyScore !== undefined && homeTeamAfterMatchPenaltyScore !== null && awayTeamAfterMatchPenaltyScore !== undefined && awayTeamAfterMatchPenaltyScore !== null
                                ? "".concat(homeTeamAfterMatchPenaltyScore, ":").concat(awayTeamAfterMatchPenaltyScore)
                                : undefined, date: isTimeKnown ? matchDate : undefined }) })), _jsx(Grid, __assign({ item: true, xs: 2, sx: { pt: 4, height: "34px" } }, { children: _jsx(MatchCallToActionButton, { reportId: reportId, liveTickerKey: liveTickerKey, buyTicketLink: buyTicketLink }) }))] })) })) })));
};
